import React, {Component} from 'react';
import AuthenticatedTemplate from '../../Components/Templates/Authenticated';
import './index.sass';
import Plans from "../../Components/Plans/index";
import Input from "../../Components/Playgrond/Input/index";
import {Button} from 'tabler-react';
import fetch from '../../support/fetch';
import Loading from '../../Components/Loading';

class NewSubscription extends Component {
    state = {
        subscriptionType: 'adult',
        couponCode: null,
        couponFormIsOpened: false,
        plansComponentIsBusy: true,
        authorized: false,
        loading: true
    };

    componentDidMount() {
        fetch.obj({
            query: `query FetchAllSubscriptions{
                subscriptions{
                    data {
                        status
                    }
                }
            }`,
            variables: {}
        })
        .then(res => {
            const subscriptions = res.data.subscriptions.data;
            let authorized = true;

            Object.keys(subscriptions).forEach((el, i) => {
                if (subscriptions[el].status !== 'CANCELED') {
                    authorized = false;
                }
            });

            this.setState({
                authorized: authorized,
                loading: false
            });
        });
    }

    openCouponForm = e => {
        this.setState({couponFormIsOpened: true});
    };

    couponFormSubmitHandler = e => {
        e.preventDefault();

        const couponInputValue = e.target.couponCode.value;

        if (couponInputValue.trim() === '' || couponInputValue.length < 3) {
            alert('Cupom inválido');
            return;
        }

        this.setState({
            couponCode: couponInputValue
        });
    };

    loadingListener = isBusy => {
        this.setState({plansComponentIsBusy: isBusy});
    };

    render() {
        return (
            <AuthenticatedTemplate withSidebar={false}>
                <div className="row">
                    <div className="col-md-2 col-xl-3">
                        <p className="display-4 display-text mt-6">Planos disponíveis para você:</p>
                        {
                            !this.state.loading && this.state.authorized &&
                            <p>
                                Você possui um cupom de desconto? Clique{' '}
                                <a href="#" onClick={this.openCouponForm}>aqui</a>{' '}
                                para informá-lo.
                            </p>
                        }

                        {
                            this.state.couponFormIsOpened &&
                            <form onSubmit={this.couponFormSubmitHandler}>
                                <div className="row gutters-xs">
                                    <div className="col">
                                        <Input
                                            name="couponCode"
                                            type="text"
                                            pipe={v => v.toUpperCase() }
                                            placeholder={
                                                this.state.plansComponentIsBusy
                                                    ? 'Aguarde, carregando...'
                                                    : 'informe o código do cupom'
                                            }
                                            disabled={this.state.plansComponentIsBusy}
                                        />
                                    </div>
                                    <div className="col-auto">
                                        <Button
                                            className={
                                                'btn ' + (
                                                    this.state.plansComponentIsBusy
                                                        ? 'btn-primary'
                                                        : 'btn-outline-primary'
                                                )
                                            }
                                            loading={this.state.plansComponentIsBusy}>inserir</Button>
                                    </div>
                                </div>
                            </form>
                        }
                    </div>

                    <div className="col-md-10 col-xl-9">
                        {
                            this.state.loading &&
                                <Loading />
                        }

                        {
                            !this.state.loading && this.state.authorized &&
                            <Plans
                                subscriberType="adult"
                                couponCode={this.state.couponCode}
                                loading={this.loadingListener}
                            />
                        }

                        {
                            !this.state.loading && !this.state.authorized &&
                            <React.Fragment>
                                <h1 className="display-3 text-center text-red pt-7" style={{fontSize: '32px'}}>
                                    Operação não permitida!
                                </h1>
                                <p className="text-center">
                                    Para criar uma nova assinatura, todas as assinaturas vinculadas à{' '}
                                    sua conta precisam estar canceladas.
                                    <br/>
                                    Certifique-se de cancelá-las antes de prosseguir.
                                    <br/>
                                    <br/>
                                    <span className="small">
                                        Possui dúvidas? Entre em contato com o nosso{' '}
                                        <a
                                            href="https://ooppah.zendesk.com/hc/pt-br"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >suporte</a>.
                                    </span>
                                </p>
                            </React.Fragment>
                        }
                    </div>
                </div>
            </AuthenticatedTemplate>
        );
    }
}

export default NewSubscription;